import { render, staticRenderFns } from "./OperacionesView.vue?vue&type=template&id=38381b0b&"
import script from "./OperacionesView.vue?vue&type=script&lang=js&"
export * from "./OperacionesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports